/**
 * Model for SREvent object, used to package events emitted between components
 */
export interface SREvent {
  type: string;
  payload?: any;
}
